























































import Vue from 'vue'
import { FeedbackResultsModel } from '@/models/FeedbackResultsModel'
import { FeedbackRequestOwnerModel } from '@/models/FeedbackRequestOwnerModel'
import { FeedbackAnalysisModel } from '@/models/FeedbackAnalysisModel'
import ShareLinkTextField from '@/components/ShareLinkTextField.vue'
import { PagedList } from '@/models/PagedList'

const luxon = require('luxon')

const initialPageSize: number = 15

export default Vue.extend({
  name: 'FeedbackResultsList',
  components: {
  },
  props: {},
  data: () => ({
    requests: {} as PagedList<FeedbackRequestOwnerModel>,
    clickedPage: 1,
    selectedRequest: true,
    error: null as any,
    loading: false
  }),
  methods: {
    navigateToResults (requestId: string) {
      this.$router.push({ name: 'feedbackresults', params: { feedbackRequestId: requestId } })
    },
    formatDate (isoDateStr: string) {
      const dateTime = luxon.DateTime.fromISO(isoDateStr)
      return dateTime.toLocaleString() + ' ' + dateTime.toLocaleString(luxon.DateTime.TIME_SIMPLE /* luxon.DateTime.TIME_WITH_SHORT_OFFSET */)
    },
    getPage (s: number) {
      this.fetchPage(s, initialPageSize)
    },
    async fetchPage (pageNumber: number, pageSize: number) {
      await this.$store.dispatch('searchFeedbackRequests', { pageNumber: pageNumber, pageSize: pageSize })
        .then((feedbackRequests: PagedList<FeedbackRequestOwnerModel>) => {
          if (feedbackRequests) {
            this.requests = feedbackRequests
          }
          this.loading = false

          return Promise.resolve()
        },
        (err: any) => {
          this.error = err
        })
    }
  },
  computed: {
    hasNoData () {
      return this.requests.pageOfData && !this.requests.pageOfData.length
    }
  },
  async mounted () {
    this.$emit('sub-title-change', 'Feedback Results List')
    this.loading = true
    this.fetchPage(1, initialPageSize)
  }
})
